// src/serviceWorkerRegistration.js
//
// Este archivo activa el service worker que genera Create React App.
// El service worker cachea los archivos de la app para que funcione
// offline y cargue más rápido en visitas siguientes.
//
// Para activarlo, importa registerServiceWorker() en src/index.js

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register() {
  if ("serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);

    // El service worker solo funciona si está en el mismo origen
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // En localhost verificamos que el service worker existe
        checkValidServiceWorker(swUrl);
        navigator.serviceWorker.ready.then(() => {
          console.log("PWA: service worker activo en localhost");
        });
      } else {
        // En producción lo registramos directamente
        registerValidSW(swUrl);
      }
    });
  }
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // Cuando hay una nueva versión disponible
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Nueva versión disponible — el usuario verá los cambios al recargar
              console.log("PWA: nueva versión disponible, recarga para actualizar");
            } else {
              // Primera instalación — contenido cacheado para uso offline
              console.log("PWA: app lista para uso offline");
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Error registrando service worker:", error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (response.status === 404 || (contentType && !contentType.includes("javascript"))) {
        // No se encontró el service worker, recargamos
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log("Sin conexión — app corriendo en modo offline");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch((error) => console.error(error.message));
  }
}
